module.exports = __webpack_public_path__ + "static/media/GITravel.6395fb37.svg";